"use strict";
exports.__esModule = true;
exports.Time = void 0;
var Time = /** @class */ (function () {
    function Time() {
    }
    /**
     * recent
     *
     * @method faker.time.recent
     * @param outputType 'abbr' || 'wide' || 'unix' (default choice)
     */
    Time.prototype.recent = function (outputType) {
        if (outputType === void 0) { outputType = 'unix'; }
        // TODO @Shinigami92 2022-01-11: This is not non-deterministic
        // https://github.com/faker-js/faker/pull/74/files#r781579842
        var date = new Date();
        switch (outputType) {
            case 'abbr':
                date = date.toLocaleTimeString();
                break;
            case 'wide':
                date = date.toTimeString();
                break;
            case 'unix':
                // TODO @Shinigami92 2022-01-10: add default case
                date = date.getTime();
                break;
        }
        return date;
    };
    return Time;
}());
exports.Time = Time;
